import { DataResult } from '../model/DataResult';

export const DEFAULT_VALUE: string = '-';

export default interface FormatProps extends DataResult {
  showDefaultValue?: boolean;
  /** Optional extra class name(s) applied alongside the format container class. */
  className?: string;
}
